import { toast } from "react-toastify";
import { getApiBaseUrl } from "../../utils/apiBaseUrl";

/**
 * @param id - The ID of the address to update.
 * @param payload - The address data to update.
 * @param token - The authentication token.
 * @returns A promise that resolves to the API response.
 */
export async function confirmUpdateLocationWithPamCodeChangeAsync(
    addressId: string,
    payload: any,
    token: string,
    t: (key: string) => string
  ): Promise<any> {

    if (!navigator.onLine) {
      toast.error(t("internetConnection"), { toastId: "offline-error" });    
      return null;
    }

    
    try {
      const baseUrl = getApiBaseUrl();
      const response = await fetch(
        `${baseUrl}/api/Address/ConfirmUpdateAddressWithPamCodeChangeAsync?addressId=${addressId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Failed to update location: ${errorData.message}`);
      }
  
      const result = await response.json();
      return result;
    } catch (error) {
      // console.error("Error updating location:", error);
      throw error;
    }
  }
  